 /**
 * 操作权限处理
 *
 */

export default {
  inserted(el, binding) {
    const { value } = binding
    const all_permission = "*:*:*";

    if(localStorage.getItem("accountTypePermission")==1){
      return true
    }
    // 这里从localStorage拿到用户的所有权限码
    const permissions = JSON.parse(localStorage.getItem("permissionCodeList"))
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}
